import styled, { css } from 'styled-components';

import { PasswordValidationList } from '../../../components';
import { StyledColumn } from '../../../components/PasswordValidationList/styled';

export const StyledInputSection = styled.div`
  display: grid;
  gap: ${({ theme }): string => theme.spacers!.spacer04};
`;

export const PasswordValidationListWrapper = styled(PasswordValidationList)(
  ({ theme: { spacers, admanColors } }) => css`
    font-family: InspireTWDC;
    display: flex;
    gap: ${spacers!.spacer03};
    color: ${admanColors!.gray.dark.bg3[1]};

    ul {
      padding: 0;

      li {
        font-size: 14px;
        line-height: 21px;
        margin-left: 0;

        ::before {
          font-size: 20px;
          margin-right: ${spacers!.spacer02};
        }
      }
    }
    ${StyledColumn} {
      min-width: initial;
      flex-basis: 50%;
    }
  `
);

export const StyledBottomPart = styled.div(
  ({ theme: { admanColors } }) => css`
    display: flex;
    flex-direction: column;
    gap: 40px;
    position: relative;
    color: ${admanColors!.gray.light.fg[0]};
    font-family: Graphik;

    .TrekCheckbox-container label > span {
      text-transform: none;
      font-weight: normal;
      font-size: 12px;
      position: absolute;
      line-height: 18px;
      letter-spacing: normal;

      a {
        color: ${admanColors!.blue.solid};
        text-decoration: none;
      }
    }
  `
);

export const StyledButtonWrapper = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    margin-top: ${spacers!.spacer06};
    margin-bottom: ${spacers!.spacer04};

    button {
      margin: auto;
      display: block;

      &.TrekButton-disabled {
        color: ${admanColors!.gray.dark.fg[0]};
        background-color: ${admanColors!.gray.light.fg[5]};
      }
    }
  `
);
